import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import './index.scss'
import {Checkbox, message, Modal} from 'antd'
import { pgHandlernew,pgEditHandlernew} from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import CButton from '@/components/CButton'
import CCheckbox from "../../../components/CForm/CCheckbox";

@CBaseComponent
class ProcessManagement extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.modalOk = this.modalOk.bind(this);
    this.modalCancel = this.modalCancel.bind(this);
    this.onClick = this.onClick.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
      title:'',
      visible:false,
      titles:'',
      steps:[],
      tips:'',
      id:'',
      value:[]
  };

  onClick(data,id){
    if (data === '') {
      this.setState({
        id:id
      },()=>{
        this.modalOk()
      })
    } else {
      this.setState({
        visible: true,
        tips:data,
        id:id
      })
    }

  }

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    pgHandlernew().then(res=>{
      if (res.statecode === 0) {
        const r = []
        res.records.forEach((item,index)=>{
          item.type = 'n'
          if (item.value === 'y'){
            r.push(index+'i')
          }
          item.value = index+'i'
        })
        this.setState({

        })
        this.setState({
          value: r,
          steps:res.records
        })
      } else {
        message.error(res.statemessage);
      }

    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  modalOk(){
    const obj = {}
    this.state.steps.forEach(item=>{
      this.state.value.forEach(item2=>{
        if (item.value === item2){
          item.type = 'y'
        }
      })
    })
    this.state.steps.forEach(item=>{
      obj[`${item.name}`] = item.type
    })
    pgEditHandlernew(obj).then(res=>{
      message.success('编辑成功');
      this.getListData()
      this.modalCancel()
    })
  }

  modalCancel(){
    this.setState({
      visible: false,
      tips: '',
      id:''
    })
  }

  onChange(value){
    this.setState({
      value: value
    })
  }


  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          {
            this.state.steps.length > 0 &&
              <div>
                <Checkbox.Group onChange={(e) => this.onChange(e)} value={this.state.value}>
                  {
                    this.state.steps.map((item=>{
                      return <Checkbox key={item.value} checked={this.state.value} value={item.value} style={{marginBottom:'20px',marginRight:'10px',marginLeft:'0px',width:'30%'}}>{item.name}</Checkbox>
                    }))
                  }
                </Checkbox.Group>
                <CButton size='larger' type='primary' className="confirm" onClick={this.modalOk}>保存</CButton>
              </div>
          }
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ProcessManagement);
